module.exports = __webpack_public_path__ + "static/media/round_end.88ef19a2.mp3";